// 教室に関する定数
export default {
  spareRooms: [ '予備席' ]   // 予備の教室名一覧
}



// WEBPACK FOOTER //
// ./src/constants/ClassroomConstants.js